var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 256 256"
    },
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00A388;}\n\t.st1{fill:#EA685E;stroke:#00886F;stroke-width:15;stroke-miterlimit:10;}\n\t.st2{fill:#E8E8E8;}\n\t.st3{fill:#FFFFFF;stroke:#00886F;stroke-width:15;stroke-miterlimit:10;}\n\t.st4{fill:#00886F;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#CCCCCC;}\n\t.st7{fill:none;stroke:#00A388;stroke-width:4;stroke-miterlimit:10;}\n\t.st8{fill:#EA685E;}\n\t.st9{fill:#FFAB80;}\n\t.st10{fill:#2C3E50;}\n\t.st11{fill:#4B687F;}\n\t.st12{fill:none;stroke:#3E5063;stroke-width:4;stroke-miterlimit:10;}\n\t.st13{fill:#FFD766;}\n\t.st14{fill:#FFE6D3;}\n\t.st15{fill:#F09A79;}\n\t.st16{fill:#C91E01;}\n\t.st17{fill:#EA3B28;}\n\t.st18{fill:#0F627F;}\n\t.st19{fill:#005670;}\n\t.st20{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st21{mask:url(#SVGID_2_);}\n\t.st22{fill:#8C623B;}\n\t.st23{fill:#E6E6E6;stroke:#005670;stroke-width:16;stroke-miterlimit:10;}\n\t.st24{opacity:0.6;}\n\t.st25{fill:#E6E6E6;}\n\t.st26{fill:#FFEC82;}\n\t.st27{fill:#FFCF3A;}\n\t.st28{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st29{mask:url(#SVGID_1_);}\n\t.st30{fill:#603813;}\n\t.st31{fill:#F2F2F2;}\n\t.st32{fill:#666666;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 128,
    cy: 128,
    r: 120
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 128,
    cy: 132,
    r: 72.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 128,
    cy: 124,
    r: 72.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    height: 21.06296,
    transform: "matrix(-0.707107 0.707107 -0.707107 -0.707107 312.554871 136.535538)",
    width: 93.42083,
    x: 81.289589,
    y: 122.468521
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    height: 21.06296,
    transform: "matrix(0.707107 0.707107 -0.707107 0.707107 131.535538 -51.554871)",
    width: 93.42083,
    x: 81.289589,
    y: 122.468521
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 21.06296,
    transform: "matrix(-0.707107 0.707107 -0.707107 -0.707107 309.019348 128)",
    width: 93.42083,
    x: 81.289589,
    y: 117.468521
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 21.06296,
    transform: "matrix(0.707107 0.707107 -0.707107 0.707107 128 -53.019337)",
    width: 93.42083,
    x: 81.289589,
    y: 117.468521
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.0dd8d65dca2c6dcb5f54eb6b309b2b6a.svg";
export { ForwardRef as ReactComponent };